import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";
import { weekDays } from "./scheduleManagerConstants";

const ScheduleSlotDialog = ({
  open,
  onOpenChange,
  editSlotId,
  timeSlotForm,
  setTimeSlotForm,
  handleSaveTimeSlot,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {editSlotId ? t("planning.scheduleManager.slotDialog.editTitle") : t("planning.scheduleManager.slotDialog.createTitle")}
          </DialogTitle>
          <DialogDescription>{t("planning.scheduleManager.slotDialog.description")}</DialogDescription>
        </DialogHeader>

      <div className="space-y-4 py-4">
        <div className="space-y-2">
          <Label>{t("planning.scheduleManager.slotDialog.weekDay")}</Label>
          <Select
            value={timeSlotForm.week_day}
            onValueChange={(value) => setTimeSlotForm({ ...timeSlotForm, week_day: value })}
          >
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              {weekDays.map((day) => (
                <SelectItem key={day.value} value={day.value}>{t(day.labelKey)}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>{t("planning.scheduleManager.form.startTime")}</Label>
            <Input
              type="time"
              value={timeSlotForm.start_time}
              onChange={(e) => setTimeSlotForm({ ...timeSlotForm, start_time: e.target.value })}
            />
          </div>
          <div className="space-y-2">
            <Label>{t("planning.scheduleManager.form.endTime")}</Label>
            <Input
              type="time"
              value={timeSlotForm.end_time}
              onChange={(e) => setTimeSlotForm({ ...timeSlotForm, end_time: e.target.value })}
            />
          </div>
        </div>

        <div className="space-y-3 border rounded-lg p-3 bg-muted/50">
          <div className="flex items-center justify-between">
            <Label className="text-sm font-medium">{t("planning.scheduleManager.form.includeBreak")}</Label>
            <button
              type="button"
              onClick={() =>
                setTimeSlotForm((prev) => ({ ...prev, break_enabled: !prev.break_enabled }))
              }
              className={`w-10 h-5 rounded-full flex items-center px-1 transition ${
                timeSlotForm.break_enabled ? "bg-primary" : "bg-muted"
              }`}
            >
              <span
                className={`w-4 h-4 bg-card dark:bg-gray-200 rounded-full shadow transform transition ${
                  timeSlotForm.break_enabled ? "translate-x-5" : ""
                }`}
              />
            </button>
          </div>

          {timeSlotForm.break_enabled && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>{t("planning.scheduleManager.form.breakStart")}</Label>
                <Input
                  type="time"
                  value={timeSlotForm.break_start}
                  onChange={(e) => setTimeSlotForm({ ...timeSlotForm, break_start: e.target.value })}
                />
              </div>
              <div className="space-y-2">
                <Label>{t("planning.scheduleManager.form.breakEnd")}</Label>
                <Input
                  type="time"
                  value={timeSlotForm.break_end}
                  onChange={(e) => setTimeSlotForm({ ...timeSlotForm, break_end: e.target.value })}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>{t("planning.scheduleManager.actions.cancel")}</Button>
        <Button onClick={handleSaveTimeSlot}>
          {editSlotId ? t("planning.scheduleManager.actions.save") : t("planning.scheduleManager.actions.add")}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
  );
};

export default ScheduleSlotDialog;
